// const returnEnv = () => {
const env = {
  apiKey: "AIzaSyCoERXsdd2hdRFRouJAnXprwQdqZVQSyyM",

  authDomain: "aleeha-single-vendor-ecom.firebaseapp.com",

  projectId: "aleeha-single-vendor-ecom",

  storageBucket: "aleeha-single-vendor-ecom.appspot.com",

  messagingSenderId: "397968866209",

  appId: "1:397968866209:web:efd895b746147d3a8de9e0",

  measurementId: "G-7NR91K36NW",
};

//   return env;
// };
export default env;
